import { ref } from 'vue'

type UsePaginationArgs = {
  initialPageSize?: number
  onPageChange?: (page: number) => void
}

export function usePagination({
  initialPageSize = 20,
  onPageChange = undefined,
}: UsePaginationArgs) {
  const pageSize = ref(initialPageSize)
  const currentPage = ref(1)

  const updatePage = (page: number) => {
    currentPage.value = page

    if (onPageChange) onPageChange(page)
  }

  const resetPagination = () => {
    currentPage.value = 1
  }

  return {
    pageSize,
    currentPage,
    updatePage,
    resetPagination,
  }
}
